import { ArrowRight } from 'lucide-react';
import { ArcheIconImg, DefaultArcheIcon } from '@/lib/arche-icon-url';

interface ArcheResultCardProps {
  arche: {
    archId: string;
    name: string;
    simpleDescription: string;
    imageRef: string | null;
  };
  onClick: () => void;
}

export function ArcheResultCard({ arche, onClick }: ArcheResultCardProps) {
  return (
    <button
      onClick={onClick}
      className="w-full p-4 rounded-xl bg-card border border-border hover:border-primary/50 hover:bg-accent/50 transition-all text-left group"
    >
      <div className="flex items-start gap-3">
        {arche.imageRef ? (
          <ArcheIconImg
            imageRef={arche.imageRef}
            size={128}
            alt={arche.name}
            className="w-12 h-12 rounded-lg object-cover flex-shrink-0"
          />
        ) : (
          <DefaultArcheIcon className="w-12 h-12 rounded-lg flex-shrink-0" />
        )}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-medium text-foreground truncate">{arche.name}</h3>
            <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
          </div>
          <p className="text-sm text-muted-foreground line-clamp-2 mt-1">
            {arche.simpleDescription}
          </p>
        </div>
      </div>
    </button>
  );
}
